(function () {
    'use strict';

    var storeName = 'wc/store/cart';
    var countSelector = '.cart__count';

    function getCartStore() {
        if (!window.wp || !window.wp.data || typeof window.wp.data.select !== 'function') {
            return null;
        }

        return window.wp.data.select(storeName);
    }

    function updateCartCount(count) {
        var cartCount = parseInt(count, 10) || 0;
        var cartLinks = document.querySelectorAll('.cart__link');

        cartLinks.forEach(function (cartLink) {
            var badge = cartLink.querySelector(countSelector);

            if (!badge) {
                badge = document.createElement('span');
                badge.className = 'cart__count';
                cartLink.appendChild(badge);
            }

            badge.textContent = cartCount > 0 ? cartCount : '';
            badge.hidden = cartCount < 1;
        });
    }

    function syncCartCount() {
        var cartStore = getCartStore();

        if (!cartStore || typeof cartStore.getCartData !== 'function') {
            return;
        }

        if (typeof cartStore.hasFinishedResolution === 'function' && !cartStore.hasFinishedResolution('getCartData')) {
            return;
        }

        var cartData = cartStore.getCartData();

        if (cartData && typeof cartData.itemsCount !== 'undefined') {
            updateCartCount(cartData.itemsCount);
        }
    }

    function init() {
        if (!getCartStore() || !window.wp.data.subscribe) {
            return;
        }

        syncCartCount();
        window.wp.data.subscribe(syncCartCount);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();



// WEBPACK FOOTER //
// ./resources/assets/scripts/woocommerce-cart.js